import { render, staticRenderFns } from "./ContactRelatedCompanies.vue?vue&type=template&id=24ca4daa&"
import script from "./ContactRelatedCompanies.vue?vue&type=script&lang=js&"
export * from "./ContactRelatedCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports